import React, { useState, useEffect } from 'react'
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { withStyles, createStyles } from '@mui/styles';
import ClipLoader from "react-spinners/ClipLoader";
import { CreateUrl, CallGetAPI, CallPutAPI, CallDeleteAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import moment from 'moment'
import DOMPurify from 'dompurify'
import Button from '@mui/material/Button';
import Modal from 'react-bootstrap/Modal'
import TextInputBox from '../../components/Comments/TextInputBox';
import TextField from '@mui/material/TextField';
import Loader from '../../Utils/Loader/NewLoader2025'

interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
    };
}


interface ReleaseNotesData {
    text: string
    startDate: Date 
    endDate: Date 
    id: number 
    portalVersion: string
}

interface TempNotes {
    text: string
    startDate: Date | null
    endDate: Date | null
    portalVersion: string
}

const styles: Record<any, any> = {
    formControl: {
        minWidth: 120,
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        marginLeft: "20px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

const style = createStyles(styles);

const ImportData: React.FC<Props> = ({classes }) => {
    

    const [loading, setLoading] = useState<boolean>(true)
    const [releaseNoteData, setReleaseNoteData] = useState<string>("")
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [portalVersion, setPortalVersion] = useState<string>("")
    const [modal, setModal] = useState<boolean>(false)
    const [tempRelease, setTempRelease] = useState<TempNotes>({ text: "", portalVersion: "", startDate: null, endDate: null })
    const [modalTitle, setModalTitle] = useState<string>("")
    const [edit, setEdit] = useState<boolean>(false)
    const [isOpen, setIsOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [status, setStatus] = useState("");
    const [taskNextRun, setTaskNextRun] = useState("");
    const [processed, setProcessed] = useState([]); 
    const [waiting, setWaiting] = useState([]); 
    const [processing, setProcessing] = useState([]); 
    const [failed, setFailed] = useState([]); 
    const [logContent, setLogContent] = useState<string>("");

  
    const toggleModal = ():void => {
        setModal(!modal)
    }

  

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!file) {
            setStatus("Please select a CSV file first.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            setStatus("Uploading...");
            const requestOptions = {
                method: "POST",
                body: formData
            }
            console.log(formData);
            CallPostAPI(CreateUrl('/api/aquaguard/importDataUpload'), requestOptions)
                .then(response => {
                    console.log(response);
                    if (response.ok) {
                        setStatus("Success");
                        loadData();
                    } else {
                        setStatus("Error Uploading File")
                    }
                })     
        } catch (error) {
            setStatus(`Error: ${e.message}`);
        }
    };

    const refreshPage = (): void => {
      //  window.location.reload();
    }

    useEffect(() => {
        loadData();
        const intervalId = setInterval(() => {
            loadData();
        }, 60000);

        // Clean up interval on unmount
        return () => clearInterval(intervalId); 
    }, [])
 
    const loadData = (): void => {
        CallGetAPI(CreateUrl('/api/aquaguard/GetDataUploadProgress'), {})
            .then(response => {

                setFailed(response.failed);
                setProcessing(response.processing);
                setProcessed(response.processed);
                setWaiting(response.waiting);
                setLogContent(response.errorLog);
                setTaskNextRun(response.nextRun);

            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    };

    return (<div>
        <div>
            <Modal
                show={modal}
                style={{

                    position: 'absolute', left: '50%', top: "50%",
                    transform: 'translate(-50%, -40%)',
                    zIndex: 1
                }}
            >
            </Modal>
            <GridContainer >
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" className="view view-cascade  d-flex justify-content-between align-items-center py-2 mx-4 mb-3">
                            <h4 className={classes.cardTitleWhite}>Import Chariot Data</h4>
                            
                        </CardHeader>
                        <CardBody>
                            <div style={{ display: "flex", justifyContent: "center", }}>
                                <div style={{ display: "flex", margin: "20px 0", border: "1px solid black", width: "90%", padding: "20px" }} >
                                    <div style={{ width: "50%", padding: "20px" }} > 
                                        <h1>Import Chariot data</h1>
                                        <p>Upload a CSV file below.  The data will be imported into the log readings table and then can be viewed on the Portal.</p>
                                        <ul>
                                            <li>Only include data for one serial number per file.</li>
                                        </ul>
                                        <div className="border border-gray-300 p-4 rounded-lg max-w-2xl">
                                            <h4 className="text-lg font-semibold mb-2">Example CSV Format</h4>
                                            <p className="mb-4">
                                                The CSV file should have the following headers and structure:
                                            </p>
                                            <table className="w-full border-collapse text-left">
                                                <thead>
                                                    <tr className="bg-gray-100">
                                                        <th className="border border-gray-300 px-2 py-1">Serial</th>
                                                        <th className="border border-gray-300 px-2 py-1">Date</th>
                                                        <th className="border border-gray-300 px-2 py-1">Time</th>
                                                        <th className="border border-gray-300 px-2 py-1">FlowRate</th>
                                                        <th className="border border-gray-300 px-2 py-1">Channel</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="border border-gray-300 px-2 py-1">75569</td>
                                                        <td className="border border-gray-300 px-2 py-1">15/08/2025</td>
                                                        <td className="border border-gray-300 px-2 py-1">13:01:00</td>
                                                        <td className="border border-gray-300 px-2 py-1">4.1</td>
                                                        <td className="border border-gray-300 px-2 py-1">A</td>

                                                    </tr>
                                                    <tr>
                                                        <td className="border border-gray-300 px-2 py-1">75569</td>
                                                        <td className="border border-gray-300 px-2 py-1">15/08/2025</td>
                                                        <td className="border border-gray-300 px-2 py-1">13:02:00</td>
                                                        <td className="border border-gray-300 px-2 py-1">4.9</td>
                                                        <td className="border border-gray-300 px-2 py-1">A</td>

                                                    </tr>
                                                    <tr>
                                                        <td className="border border-gray-300 px-2 py-1">75569</td>
                                                        <td className="border border-gray-300 px-2 py-1">15/08/2025</td>
                                                        <td className="border border-gray-300 px-2 py-1">13:03:00</td>
                                                        <td className="border border-gray-300 px-2 py-1">4.0</td>
                                                        <td className="border border-gray-300 px-2 py-1">A</td>

                                                    </tr>
                                                    <tr>
                                                        <td className="border border-gray-300 px-2 py-1">75569</td>
                                                        <td className="border border-gray-300 px-2 py-1">15/08/2025</td>
                                                        <td className="border border-gray-300 px-2 py-1">13:04:00</td>
                                                        <td className="border border-gray-300 px-2 py-1">4.4</td>
                                                        <td className="border border-gray-300 px-2 py-1">A</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        {status == '' || status == 'Success' ? <form onSubmit={handleSubmit}>
                                            <input
                                                type="file"
                                                accept=".csv"
                                                onChange={handleFileChange}
                                                style={{ marginRight: "10px", padding: "10px" }}
                                            />

                                            <Button
                                                type="submit" variant="contained"
                                                color="primary" style={{ marginRight: "10px" }}>
                                                Upload
                                            </Button>

                                        </form> : <p style={{ fontWeight: 'bold' }} >Status: {status}</p>}
                                        
                                    </div>
                                    <div style={{ width: "50%", borderLeft: "1px solid black", padding:"20px"}} > 
                                        <h2>Import Progress..</h2>  
                                             <p style={{ fontWeight: 'bold' }} >The next import process will run at {taskNextRun.toString()}</p>
                                          
                                        <p style={{ fontWeight:"bold"}}>Waiting..</p>
                                        {waiting.length > 0 ? (
                                            <ul style={{ maxHeight: "80px", overflowY: "auto" }}>
                                                {waiting.map((file, index) => (
                                                    <li key={index}>{file}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-gray-500">No files</p>
                                        )}
                                        <p style={{ fontWeight: "bold" }}>Processing..</p>
                                        {processing.length > 0 ? (
                                            <ul style={{ maxHeight: "80px", overflowY:"auto"}}>
                                                {processing.map((file, index) => (
                                                    <li key={index}>{file}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-gray-500">No files</p>
                                        )}
                                        <p style={{ fontWeight: "bold" }}>Processed..</p>
                                        {processed.length > 0 ? (
                                            <ul style={{ maxHeight: "80px", overflowY: "auto" }}>
                                                {processed.map((file, index) => (
                                                    <li key={index}>{file}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-gray-500">No files</p>
                                        )}
                                        <p style={{ fontWeight: "bold" }}>Failed..</p>
                                        {failed.length > 0 ? (
                                            <ul style={{ maxHeight: "80px", overflowY: "auto" }}>
                                                {failed.map((file, index) => (
                                                    <li key={index}>{file}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-gray-500">No files</p>
                                        )}
                                        {logContent === "" ? null :
                                            (<div style={{ padding: "10px",maxHeight: "200px", overflowY: "auto", border: "1px solid #ccc" }}>
                                                <pre style={{ color: "red", margin: 0 }}>{logContent}</pre>
                                            </div>)
                                         }
                                        
                                    </div>
                                </div>
                                    
                              
                            </div>
                          
                        </CardBody>
                    </Card>
                </GridItem>

            </GridContainer>


        </div>
    </div>)
}
export default withStyles(style)(ImportData)